// Compact "Your Progress" card for the Field Worker home + Nearly There.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, Trophy, ChevronRight } from "lucide-react";
import api from "@/lib/api";

export default function FieldProgressCard() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/progress/me").then((r) => setD(r.data)).catch(() => {});
  }, []);
  if (!d || (!d.enabled?.streaks && !d.enabled?.achievements)) return null;
  const s = d.summary;
  const n = d.nearly_there;
  return (
    <Link to="/app/progress" className="block mb-4" data-testid="field-progress-card">
      <div className="bg-white dark:bg-[#101620] border border-zinc-200 dark:border-white/[0.07] rounded-2xl p-4 active:scale-[0.99] transition-transform">
        <div className="flex items-center justify-between">
          <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-zinc-500">Your progress</span>
          <ChevronRight className="w-4 h-4 text-zinc-500" />
        </div>
        <div className="flex items-center gap-5 mt-2.5">
          <div className="flex items-center gap-2">
            <Flame className="w-5 h-5 text-[#FF5F15]" />
            <div className="leading-tight">
              <p className="font-display font-black text-xl leading-none" data-testid="home-streak-count">{s.streak_current}</p>
              <p className="text-[11px] font-bold uppercase tracking-wider text-zinc-500">Day streak</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Trophy className="w-5 h-5 text-amber-400" />
            <div className="leading-tight">
              <p className="font-display font-black text-xl leading-none" data-testid="home-badge-count">{s.achievements_earned}</p>
              <p className="text-[11px] font-bold uppercase tracking-wider text-zinc-500">Achievements</p>
            </div>
          </div>
          {n && (
            <div className="flex-1 min-w-0 border-l border-white/10 pl-3" data-testid="nearly-there">
              <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#FF5F15]">Nearly there</p>
              <p className="text-[11px] font-bold truncate">{n.name}</p>
              <div className="h-1 bg-white/10 rounded-full overflow-hidden mt-1">
                <div className="h-full bg-[#FF5F15]" style={{ width: `${Math.min((n.progress / n.target) * 100, 100)}%` }} />
              </div>
              <p className="text-[11px] font-mono text-zinc-500 mt-0.5">{n.progress} / {n.target}</p>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
